export const normalizeText = (value, flags = {}) => {
  if (typeof value !== 'string') return value;
  const { lowercase = false, replaceSpaces = false, alphanumericOnly = false } = flags;

  let result = value;

  if (lowercase) {
    result = result.toLowerCase();
  }

  // Replace spaces with underscore if explicitly requested OR when alphanumericOnly is active
  // so that spaces aren't dropped by the alphanumeric filter.
  if (replaceSpaces || alphanumericOnly) {
    result = result.replace(/\s+/g, '_');
  }

  if (alphanumericOnly) {
    // Keep a-z, 0-9 and underscore to align with app usage
    result = result.replace(/[^0-9a-z_]+/gi, '');
  }

  // Collapse consecutive underscores (do NOT trim start/end underscores during typing)
  result = result.replace(/_+/g, '_');

  return result;
};

export default normalizeText;


